/** Object form allowed inside app query keys. */
export type AppQueryKeyRecord = {
  readonly [key: string]: AppQueryKeyValue;
};

/** Stable, serializable values allowed in app query keys. */
export type AppQueryKeyValue =
  | string
  | number
  | boolean
  | null
  | readonly AppQueryKeyValue[]
  | AppQueryKeyRecord;

export enum AppQueryDomain {
  ALGOLIA = 'algolia',
  CHATS = 'chats',
  EXPLORER = 'explorer',
  FOLLOWS = 'follows',
  GROUPS = 'groups',
  PLACES = 'places',
  PLANS = 'plans',
  REQUESTS = 'requests',
  USERS = 'users',
}

export enum AppQueryKeySegment {
  ADD_COMMENT_MUTATION = 'add-comment-mutation',
  ADMINS = 'admins',
  AUTOCOMPLETE = 'autocomplete',
  BLOCK_MUTATION = 'block-mutation',
  COMMENTS = 'comments',
  CREATE_MUTATION = 'create-mutation',
  DELETE_MUTATION = 'delete-mutation',
  DETAIL = 'detail',
  FOLLOW_MUTATION = 'follow-mutation',
  FOLLOW_RESPONSE_MUTATION = 'follow-response-mutation',
  FOLLOWERS = 'followers',
  FOLLOWING = 'following',
  GROUPS = 'groups',
  INVITES = 'invites',
  JOIN_GROUP_MUTATION = 'join-group-mutation',
  JOIN_GROUP_RESPONSE_MUTATION = 'join-group-response-mutation',
  JOIN_PLAN_MUTATION = 'join-plan-mutation',
  JOIN_PLAN_RESPONSE_MUTATION = 'join-plan-response-mutation',
  LARGEST = 'largest',
  LIKE_MUTATION = 'like-mutation',
  LIKE_STATUS = 'like-status',
  LIKES = 'likes',
  LIST = 'list',
  MEMBERS = 'members',
  MOST_FOLLOWED = 'most-followed',
  ONBOARDING_STATUS = 'onboarding-status',
  PRIVATE_CREATE_MUTATION = 'private-create-mutation',
  REGION_PLANS = 'region-plans',
  SELECTION_MUTATION = 'selection-mutation',
  SUBSCRIPTION = 'subscription',
  UPDATE_MUTATION = 'update-mutation',
  USERS = 'users',
}

/** Shared query key shape used by app query wrappers. */
export type AppQueryKey = readonly [AppQueryDomain, ...AppQueryKeyValue[]];

export function createQueryKey<const TParts extends AppQueryKey>(...parts: TParts): TParts {
  return parts;
}

export function createQueryIdListKeyPart(ids?: Iterable<string> | null): readonly string[] {
  if (!ids) return [];

  return [...new Set([...ids].filter((id) => id.length > 0))].sort();
}

export function nullableQueryKeyPart<T extends AppQueryKeyValue>(
  value: T | null | undefined
): T | null {
  return value ?? null;
}
